import React, { useState, useEffect } from 'react';
import './HeroSection.css';
import '../App.css';
import { useLanguage } from '../context/LanguageContext';

function HeroSection() {
  const { t, setLanguage } = useLanguage();
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const targetDate = new Date('2026-08-29T00:00:00');
    const interval = setInterval(() => {
      const now = new Date();
      const difference = targetDate - now;

      if (difference <= 0) {
        clearInterval(interval);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } else {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / (1000 * 60)) % 60);
        const seconds = Math.floor((difference / 1000) % 60);

        setTimeLeft({ days, hours, minutes, seconds });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className='hero-container'>
      <div className='language-switcher'>
        <button onClick={() => setLanguage('es')} className={`lang-btn ${t.lang === 'es' ? 'active' : ''}`}>ES</button>
        <span className="separator">|</span>
        <button onClick={() => setLanguage('en')} className={`lang-btn ${t.lang === 'en' ? 'active' : ''}`}>EN</button>
        <span className="separator">|</span>
        <button onClick={() => setLanguage('fr')} className={`lang-btn ${t.lang === 'fr' ? 'active' : ''}`}>FR</button>
      </div>
      <div className='header-content'>
        <h2>Fernanda & Bruno</h2>
        <h1>{t.hero_date}</h1>
        <div className='countdown-timer'>
          <div className='timer'>
            <div className='time-box'>
              <span className='time'>{timeLeft.days}</span>
              <span className='label'>{t.hero_days}</span>
            </div>
            <div className='time-box'>
              <span className='time'>{timeLeft.hours}</span>
              <span className='label'>{t.hero_hours}</span>
            </div>
            <div className='time-box'>
              <span className='time'>{timeLeft.minutes}</span>
              <span className='label'>{t.hero_minutes}</span>
            </div>
            <div className='time-box'>
              <span className='time'>{timeLeft.seconds}</span>
              <span className='label'>{t.hero_seconds}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;